
import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { ApiService } from '../services/contratos/contratos.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable, map, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { format } from 'date-fns';
import { ClrModal } from '@clr/angular';
import { AutenticacaoService } from '../autenticacao/autenticacao.service';
import { UsuarioLogado } from '../autenticacao/usuario-logado.type';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';
import * as fs from 'file-saver'; // Importe a biblioteca file-saver
import * as ExcelJS from 'exceljs';
import { readFile } from 'xlsx';


@Component({
    selector: 'app-relatorio-interplantas',
    templateUrl: './relatorio-interplantas.component.html',
    styleUrls: ['./relatorio-interplantas.component.css'],
    styles: [`
    .mat-dialog-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      background-color: #fff;
    }
  `],
    standalone: false
})

export class RelatorioInterplantasComponent {
  fieldBeingEdited!: string;
  editedValue: any;
  argentina!: any[];
  perfilVehicles: string[] = [
    'Pequeno',
    'Medio',
    'Grande',

  ];
  combustiveis: string[] = [
    'Diesel',
    'Gás',
    'Elétrico',

  ];
  item: any = {
    ID: '',
    local: '',
    contato: '',
    endereco: '',
    latitude: '',
    longitude: '',
    descarga: false
  };
  urlAtualiza: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  urlConsultaCompactada: string = 'https://q9hhz5wjah.execute-api.sa-east-1.amazonaws.com/volumeGD';
  query: string = 'dadosInterplantas';
  query2: string = 'Carriers';
  query3: string = 'tipos_Veiculos_Karrara';
  query4: string = 'items_Excel_Karrara';
  data: any;
  base: number = 3;
  ID: number = Date.now();
  local: string = "";
  contato: string = "";
  endereco: string = "";
  comentario: string = "";
  exponent: number = 22;
  $even: any;
  $odd: any;
  dataSource: any;
  dialogRef: any;
  items$!: Observable<any[]>;
  items: any[] = [];
  name!: string;
  animal!: string;
  dialogOpen = false;
  dialogTiposOpen = false;
  carrier!: any[];
  veiculos!: any[];
  teste!: boolean;
  startDate!: string;
  // startDate: string = new Date().toISOString();
  endDate!: string;
  // endDate: string = new Date().toISOString();
  milkRunSP: boolean = false;
  milkRunSul: boolean = false;
  milkRunArg: boolean = false;
  filteredItems!: any[];

  usuarioLogado!: UsuarioLogado;
  isCarrierTCMEnabled: boolean = true;
  isCarrierJSLEnabled: boolean = true;
  isCarrierJSLVWEnabled: boolean = true;
  isCarrierLOTSEnabled: boolean = true;
  isCarrierJSLARGEnabled: boolean = true;
  isCarrierEnabled: boolean = true;

  totalItensValidos!: number;
  valorDoisTotal!: number;
  valorUmTotal!: number;
  isLoading: boolean = true;
  fileName: string = 'Relatorio.xlsx';
  itemToExport!: any[];
  dataMilissegundos: number[] = [];
  somaTotalDistance!: number;
  somaWeightLoaded!: number;
  emissao!: number;
  groupedItems: any;
  results: any;
  percursoData: any = {};
  percursoArray!: any[];
  
  dateStart: Date = new Date();
  // startDateFilter: Date = new Date();// Data de início do intervalo selecionado
  // endDateFilter: Date = new Date(); // Data de término do intervalo selecionado
  startDateFilter!: Date;
  endDateFilter!: Date;
  dateEnd: Date = new Date();
  itemsFiltrados: any[] = [];
  filterColumn: string = 'dataPainel';
  referenceDate!: string;
  numDays: number = 2;
  pesoTotalML: any;
  pesoPorMU: any;
  pesoViagem: any;

  constructor(
    public dialog: MatDialog,
    private dynamodbService: ApiService,
    private http: HttpClient, private cdr: ChangeDetectorRef,
    private servicoAutenticacao: AutenticacaoService,
    private router: Router
  ) { }

  async ngOnInit(): Promise<void> {
    //console.log(this.referenceDate)
    // try {
    //   await this.getItemsFromArgentina();
    //   await this.getItemsFromDynamoDB();
    //   await this.getCarriersFromDynamoDB();
    //   await this.getVeiculosFromDynamoDB();
    //   await this.getUserLogado();
    //   this.centerDialog();

    //   this.filteredItems = await this.items.concat(this.argentina);
    //   //console.log(this.filteredItems)
    //   this.somarQuantidades();
    // } catch (error) {
    //   console.error('Erro durante a execução do ngOnInit:', error);
    // }
    await this.update();
    await this.applyFilter();
    // //console.log(this.itemsFiltrados)
    this.agrupaItems();   
    this.isLoading = false;
  }
  
  convertTimestampToFormattedDate(timestamp: number): string {
    // Converta para segundos dividindo por 1000
    const timestampSeconds = timestamp / 1000;
    // Crie um objeto Date
    const date = new Date(timestampSeconds * 1000); // Multiplique por 1000 para obter milissegundos
    // Formate a data no formato desejado
    const formattedDate = date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false // Use formato de 24 horas
    }).replace(',', ''); // Remova a vírgula

    return formattedDate;
  }

  
  agrupaItems() {
    this.percursoData = {};
    // //console.log(this.itemsFiltrados)
    this.groupedItems = this.groupByPercurso(this.itemsFiltrados);
    // //console.log(this.groupedItems);
    for (const percurso in this.groupedItems) {
      if (this.groupedItems.hasOwnProperty(percurso)) {
        const items = this.groupedItems[percurso];

        // Verificar se todos os valores de masterLabel são iguais
        const isMasterLabelEqual = items.every((item: { masterLabel: any; }) => item.masterLabel === items[0].masterLabel);

        // Usar reduce para combinar os valores e somar pesoPorMU e pesoTotalML
        const reducedItem = items.reduce((accumulator: {
          percurso: any;
          placa: any;
          tipoAbastecimento: any; ID: any; dataPainel: any; observacao: any; pesoPorMU: any; pesoTotalML: any; pesoViagem: any;
        }, currentItem: {
          percurso: any;
          placa: any;
          tipoAbastecimento: any; ID: any; dataPainel: any; observacao: any; pesoPorMU: any; pesoTotalML: any; pesoViagem: any;
        }) => {
          accumulator.ID = currentItem.ID; // Mantém o ID
          accumulator.dataPainel = currentItem.dataPainel; // Mantém a dataPainel
          accumulator.observacao = currentItem.observacao; // Mantém a observacao (ou pode ser ajustado se houver lógica específica)
          accumulator.percurso = currentItem.percurso; // Mantém a observacao (ou pode ser ajustado se houver lógica específica)
          accumulator.placa = currentItem.placa; // Mantém a observacao (ou pode ser ajustado se houver lógica específica)
          accumulator.tipoAbastecimento = currentItem.tipoAbastecimento; // Mantém a observacao (ou pode ser ajustado se houver lógica específica)
          
          // Verificar se todos os valores de masterLabel são iguais
          if (!isMasterLabelEqual) {
            accumulator.pesoTotalML = (accumulator.pesoTotalML || 0) + parseFloat(currentItem.pesoTotalML || 0);
            // //console.log(accumulator.pesoTotalML)
          }

          // Somar os campos pesoPorMU e pesoTotalML
          accumulator.pesoPorMU = (accumulator.pesoPorMU || 0) + parseFloat(currentItem.pesoPorMU || 0);
          // //console.log(accumulator.pesoPorMU)

          // accumulator.pesoTotalML = (accumulator.pesoTotalML || 0) + parseFloat(currentItem.pesoTotalML || 0);
          
          accumulator.pesoViagem = accumulator.pesoTotalML ? accumulator.pesoTotalML : accumulator.pesoPorMU;

          return accumulator;
        }, {});

        this.percursoData[percurso] = reducedItem;
      }
    }
    // //console.log(this.percursoData);

    // Transformar o objeto em um array
    this.percursoArray = Object.keys(this.percursoData).map(percurso => ({
      percurso,
      ...this.percursoData[percurso]
    }));

    //console.log(this.percursoArray);
  }

  async update() {
    try {
      // await this.getItemsFromArgentina();
      await this.getItemsFromDynamoDB();
      // await this.getCarriersFromDynamoDB();
      // await this.getVeiculosFromDynamoDB();
      await this.getUserLogado();
      this.centerDialog();
      this.agrupaItems();

      this.isLoading = false;
      
      // this.filteredItems = this.items
      // this.filteredItems = await this.items.concat(this.argentina);
      // // //console.log(this.filteredItems)
      // await this.somarQuantidades(this.filteredItems);
      // await this.somarTotalDistance(this.filteredItems);
      // await this.somarWeightLoaded(this.filteredItems);
      // await this.calcularEmissaoCO2(this.somaTotalDistance, this.somaWeightLoaded);
    } catch (error) {
      console.error('Erro durante a execução do ngOnInit:', error);
    }
  }  
  

  
  groupByPercurso(items: any[]) {
    return items.reduce((groups, item) => {
      const percurso = item.percurso;
      if (!groups[percurso]) {
        groups[percurso] = [];
      }
      groups[percurso].push(item);
      return groups;
    }, {});
  } 
  
  
  // async filterByDateRange(startDate: string, endDate: string): Promise<any[]> {
  //   const rangeStartDate = new Date(startDate);
  //   const rangeEndDate = new Date(endDate);
    
  //   rangeStartDate.setHours(0);
  //   rangeStartDate.setMinutes(0);
  //   rangeStartDate.setSeconds(0);

  //   // Adjust rangeEndDate to the end of the selected day (23:59:59)
  //   rangeEndDate.setHours(23);
  //   rangeEndDate.setMinutes(59);
  //   rangeEndDate.setSeconds(59);
    
  //   //console.log(rangeStartDate)
  //   //console.log(rangeEndDate)
    
  //   const filteredItems = this.items.filter(async (item) => {  
  //     const date3 = this.parseDateString(item.dataPainel);
  //     // //console.log(date3);
  //     return date3 >= rangeStartDate && date3 <= rangeEndDate;
  //   });
  //   // //console.log(filteredItems)
  //   return filteredItems;
  // }
  
  parseDateString(dateString: string) {
    try {
      const [datePart, timePart] = dateString.split(' ');
      const [day, month, year] = datePart.split('/').map(Number);
      const [hours, minutes] = timePart.split(':').map(Number);
      // Note que subtraímos 1 do mês, pois os meses em JavaScript começam em 0 (janeiro é 0, fevereiro é 1, etc.)
      return new Date(year, month - 1, day, hours, minutes);
    } catch {
    return new Date()
    }
  }


  async editPlaca(item: any, fieldName: string) {
    if (!this.isValorValido(item[fieldName])) {
      const newValue = prompt(`Insert a value for ${fieldName}:`);
      if (newValue !== null) {
        item[fieldName] = newValue;
        await this.salvarField(item); // Call salvar function after editing the field
      }
    }
  }

  async InsereComent(item: any, fieldName: string) {
    const newValue = prompt(`Insert a value for ${fieldName}:`);
    if (newValue !== null) {
      item[fieldName] = newValue;
      await this.salvarField(item); // Call salvar function after editing the field
    }

  }

  getPercentComentNotEmpty(): number {
    const totalItems = this.filteredItems.length;
    const itemsWithComent = this.filteredItems.filter(item => this.hasComent(item)).length;
    return 100 - ((itemsWithComent / totalItems) * 100);
  }

  async editField(item: any, fieldName: string) {
    if (!this.isValorValido(item[fieldName]) || this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9') {
      let newValue = prompt(`Insert a value for ${fieldName}:`);
      // Verifica se o valor é válido e não é nulo
      if (newValue !== null && newValue.trim() !== '') {
        // Remove as vírgulas do valor inserido
        const cleanedValue = newValue.replace(',', '.');
        // Converte o valor para o tipo number
        const numericValue = parseFloat(cleanedValue);
        // Verifica se é um número válido
        if (!isNaN(numericValue)) {
          item[fieldName] = numericValue;
          await this.salvarField(item); // Chama a função salvarField após editar o campo          
        } else {
          alert(`Invalid value for ${fieldName}. Please enter a valid number.`);
        }
      }
    }
  }


  isValorValido(value: any): boolean {
    return value != '' && value != null && value != undefined && value != 0;
  }



  editDialog(item: any): void {
    this.item.ID = item.ID
    this.item.local = item.local;
    this.item.contato = item.contato;
    this.item.endereco = item.endereco;
    this.item.latitude = item.latitude;
    this.item.longitude = item.longitude;
    this.item.descarga = item.descarga;
    this.dialogOpen = true;
  }

  // calcularMediaValoresValidos(): number {
  //   let soma = 0;
  //   let contador = 0;

  //   for (const item of this.filteredItems) {
  //     if (this.isValorValido(item['Weight Loaded'])) {
  //       const veiculo = this.findVeiculoByModelo(item['Transport Type']);
  //       if (veiculo && this.isValorValido(veiculo.peso)) {
  //         soma += item['Weight Loaded'] / veiculo.peso;
  //         contador++;
  //       }
  //     }
  //   }

  //   return contador > 0 ? (soma / contador) * 100 : 0;
  // }

  calcularMaiorValor(item: any, veiculo: any): number {
    const pesoLoaded = this.isValorValido(item['Weight Loaded']) ? ((item['Weight Loaded'] / veiculo.peso) * 100) : 0;
    const cubage = this.isValorValido(item.Cubage) ? ((item.Cubage / veiculo.volume) * 100) : 0;
    return Math.max(pesoLoaded, cubage);
  }

  // calcularMediaMaiorValor(): number {
  //   let soma = 0;
  //   let contador = 0;

  //   for (const item of this.filteredItems) {
  //     // //console.log("item")
  //     // //console.log(item)
  //     const veiculo = this.findVeiculoByModelo(item['Transport Type']);
  //     if (veiculo) {
  //       const maiorValor = this.calcularMaiorValor(item, veiculo);
  //       soma += maiorValor;
  //       contador++;
  //     }
  //   }
  //   return contador > 0 ? soma / contador : 0;
  // }

  // valorExisteNoModelo(transportType: string): boolean {

  //   return this.veiculos.some(veiculos => veiculos.modelo === transportType);
  // }

  // async applyDateFilter() {
  //   // Apply filter only when both startDate and endDate are selected
  //   if (this.startDate && this.endDate) {
  //     this.filteredItems = await this.filterByDateRange(this.startDate, this.endDate);
  //     //console.log("depois do filtro")
  //     // //console.log(this.filteredItems)
  //     // await this.somarQuantidades(this.filteredItems);
  //     // await this.somarTotalDistance(this.filteredItems);
  //     // await this.somarWeightLoaded(this.filteredItems);
  //     // await this.calcularEmissaoCO2(this.somaTotalDistance, this.somaWeightLoaded);
  //     // //console.log(this.somaTotalDistance)
  //   } else {
  //     // Otherwise, show all items
  //     this.filteredItems = this.items;
  //   }
  // }
  
  
    applyFilter() {
    // //console.log(this.items)
    if (this.startDateFilter && this.endDateFilter) {
      this.dateStart = new Date(this.startDateFilter); // Certifique-se de que this.startDate seja um valor válido no formato de data
      this.dateStart.setHours(0, 0, 0, 0); // Define as horas, minutos, segundos e milissegundos para zero
      this.dateStart.setDate(this.dateStart.getDate() + 1); // Acrescenta um dia

      this.dateEnd = new Date(this.endDateFilter);
      this.dateEnd.setHours(23, 59, 59, 999);
      this.dateEnd.setDate(this.dateEnd.getDate() + 1); // Acrescenta um dia
      
      //console.log(this.dateStart)
      //console.log(this.dateEnd)

      this.itemsFiltrados = this.items.filter(item => {
        // const itemDate = new Date(item.dataPainel); // Altere a propriedade 'entrada' para o campo que contém a data nos seus dados
        // itemDate.setHours(0, 0, 0, 0);
        // //console.log(item.dataPainel)
        try {
          const dateParts = item.dataPainel.split(/[\s/:\-]/); // Divide a string usando espaços, barras e dois pontos
          const day = parseInt(dateParts[0], 10);
          const month = parseInt(dateParts[1], 10) - 1; // Subtrai 1 do mês, pois os meses começam em 0
          const year = parseInt(dateParts[2], 10);
          const hours = parseInt(dateParts[3], 10);
          const minutes = parseInt(dateParts[4], 10);

          const itemDate = new Date(year, month, day, hours, minutes);
          
          // //console.log(itemDate)
          
          return itemDate >= this.dateStart && itemDate <= this.dateEnd;

        } catch {
          return null
        }
      });
      //console.log(this.itemsFiltrados)
      this.update();
    } else {
      this.itemsFiltrados = this.items;
    }
  }


  veiculoDialog(item: any): void {
    this.item.ID = item.ID
    this.item.modelo = item['Transport Type'];
    this.item.transportadora = item.transportadora;
    this.item.perfil = item.perfil;
    this.item.combustivel = item.combustivel;
    this.item.emissoes = item.emissoes;
    this.dialogTiposOpen = true;
  }

  async salvarVeiculo() {
    this.isLoading = true;
    if (this.item.ID === undefined) {
      const currentDate = new Date();
      const formattedDate = format(currentDate, 'ddMMyyyyHHmmss');
      //console.log(formattedDate);
      this.item = {
        "ID": formattedDate.toString(),
      }
    }

    delete this.item.contato;
    delete this.item.descarga;
    delete this.item.endereco;
    delete this.item.latitude;
    delete this.item.longitude;
    delete this.item.local;
    this.item.tableName = this.query3
    // Remover as barras invertidas escapadas
    const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
    const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
    // Converter a string JSON para um objeto JavaScript
    const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
    // Converter o objeto JavaScript de volta para uma string JSON
    const modifiedJsonString = JSON.stringify(jsonObject);
    //console.log(modifiedJsonString);
    // Converter a string JSON para um objeto JavaScript
    const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
    // Criar um array contendo o objeto
    const jsonArray = [jsonObject2];
    await this.dynamodbService.salvar(jsonArray, this.query3, this.urlAtualiza).subscribe(async response => {
      await this.ngOnInit();
      this.dialogTiposOpen = false;
      this.isLoading = false;
    }, error => {
      console.log(error);
    });
  }

  async salvarField(item: any) {
    this.isLoading = true;
    // Criar um array contendo o objeto
    const jsonArray = [item];
    await this.dynamodbService.salvar(jsonArray, this.query, this.urlAtualiza).subscribe(async response => {
      // Successfully saved to the database
      // setTimeout(() => {
      await this.getItemsFromDynamoDB();
      this.dialogOpen = false;
      this.isLoading = false;
    }, error => {
      console.log(error);
    });


    // }, 200);
  }

  calcularSomaCustoViagem(): number {
    let soma = 0;
    for (const item of this.filteredItems) {
      const totalCost = parseFloat(item['Total Cost']);
      if (!isNaN(totalCost)) {
        soma += totalCost;
      }
    }
    return soma;
  }

  // Função auxiliar para somar as quantidades de '1' e '2' em todas as chaves específicas
  isValorValidoEhUmOuDois(value: any): boolean {
    return this.isValorValido(value) && (value == '1' || value == '2');
  }

  // Função auxiliar para somar as quantidades de '1' e '2' em todas as chaves específicas
  // somarQuantidades(): { valorUm: number, valorDois: number, totalItensValidos: number } {
  somarQuantidades(items: any[]) {
    // //console.log(items)
    this.valorUmTotal = 0;
    this.valorDoisTotal = 0;
    this.totalItensValidos = 0;
    const chavesEspecificas = [
      'Passo Destino1',
      'Passo Destino2',
      'Passo Destino3', // Adicione aqui as outras chaves específicas
      'Passo Destino4',
      'Passo Fornecedor1',
      'Passo Fornecedor2',
      'Passo Fornecedor3',
      'Passo Fornecedor4'
    ];
    for (const item of items) {
      for (const chave of chavesEspecificas) {
        if (this.isValorValidoEhUmOuDois(item[chave])) {
          if (item[chave] == '1' || item[chave] == 1) {
            this.valorUmTotal++;
          } else if (item[chave] == '2' || item[chave] == 2) {
            this.valorDoisTotal++;
          }
          this.totalItensValidos++;
        }
      }
    }
    // //console.log("cumprimento Janelas")
    // //console.log(this.valorUmTotal)
    // //console.log(this.totalItensValidos)
    return { valorUm: this.valorUmTotal, valorDois: this.valorDoisTotal, totalItensValidos: this.totalItensValidos };
  }

  // isNumeroValido(value: any): boolean {
  //   //console.log("is valido")
  //   //console.log(typeof value)
  //   //console.log(value)
  //   return typeof value === 'number' && !isNaN(value) && isFinite(value);
  // }

  isNumeroValido(value: any): number {
    if (value === null || value === undefined) {
      return 0;
    } else if (typeof value === 'number' && !isNaN(value) && isFinite(value)) {
      return value;
    } else if (typeof value === 'string') {
      const parsedValue = parseFloat(value);
      // //console.log(parsedValue)
      return isNaN(parsedValue) ? 0 : parsedValue;
    } else {
      return 0;
    }
  }

  // Função auxiliar para somar os valores válidos da chave 'Total Distance'
  somarTotalDistance(items: any[]) {
    this.somaTotalDistance = 0;
    // //console.log(items)
    for (const item of items) {
      const valorValido = this.isNumeroValido(item['Total Distance'])
      // if (this.isNumeroValido(item['Total Distance'])) {
      // //console.log(item['Total Distance'])
      // //console.log(valorValido)
      this.somaTotalDistance += valorValido;
      // }
    }
    // return this.somaTotalDistance;
  }

  somarWeightLoaded(items: any[]) {
    this.somaWeightLoaded = 0;
    for (const item of items) {
      const valorValido = this.isNumeroValido(item['Weight Loaded'])
      // if (this.isNumeroValido(item['Weight Loaded'])) {
      this.somaWeightLoaded += valorValido;
      // }
    }
    this.somaWeightLoaded = this.somaWeightLoaded / 1000;
  }

  calcularEmissaoCO2(distanciaTotal: number, pesoTotal: number) {
    this.emissao = (distanciaTotal / 2.82) * 2.86 / pesoTotal;
  }

  hasComent(item: any): boolean {
    return item.Coment !== '' && item.Coment !== null && item.Coment !== undefined;
  }


  async salvar() {
    if (this.item.ID === undefined) {
      const currentDate = new Date();
      const formattedDate = format(currentDate, 'ddMMyyyyHHmmss');
      //console.log(formattedDate);
      this.item = {
        "ID": formattedDate.toString(),
        "contato": this.item.contato,
        "endereco": this.item.endereco,
        "local": this.item.local,
        "latitude": this.item.latitude,
        "longitude": this.item.longitude,
        "descarga": this.item.descarga
      }
    }
    this.item.tableName = this.query
    // Remover as barras invertidas escapadas
    const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
    const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
    // Converter a string JSON para um objeto JavaScript
    const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
    // Converter o objeto JavaScript de volta para uma string JSON
    const modifiedJsonString = JSON.stringify(jsonObject);
    //console.log(modifiedJsonString);
    // Converter a string JSON para um objeto JavaScript
    const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
    // Criar um array contendo o objeto
    const jsonArray = [jsonObject2];
    await this.dynamodbService.salvar(jsonArray, this.query, this.urlAtualiza).subscribe(async response => {
      await this.getItemsFromDynamoDB();
      this.dialogOpen = false;
      this.isLoading = false;
    }, error => {
      console.log(error);
    });
  }

  cancel(): void {
    this.dialogOpen = false;
    this.dialogTiposOpen = false;
  }

  // findVeiculoByModelo(modelo: string): any {
  //   return this.veiculos.find(veiculo => veiculo.modelo === modelo);
  // }

  // calcularPorcentagemVeiculosPequenos(): number {
  //   const totalVeiculos = this.filteredItems.length;
  //   const veiculosPequenos = this.filteredItems.filter(item => {
  //     const veiculo = this.findVeiculoByModelo(item['Transport Type']);
  //     return veiculo && veiculo.perfil === 'Pequeno';
  //   }).length;
  //   return (veiculosPequenos / totalVeiculos) * 100;
  // }

  // calcularPorcentagemVeiculosMedios(): number {
  //   const totalVeiculos = this.filteredItems.length;
  //   const veiculosMedios = this.filteredItems.filter(item => {
  //     const veiculo = this.findVeiculoByModelo(item['Transport Type']);
  //     return veiculo && veiculo.perfil === 'Medio';
  //   }).length;
  //   return (veiculosMedios / totalVeiculos) * 100;
  // }

  // calcularPorcentagemVeiculosGrandes(): number {
  //   const totalVeiculos = this.filteredItems.length;
  //   const veiculosGrandes = this.filteredItems.filter(item => {
  //     const veiculo = this.findVeiculoByModelo(item['Transport Type']);
  //     return veiculo && veiculo.perfil === 'Grande';
  //   }).length;
  //   return (veiculosGrandes / totalVeiculos) * 100;
  // }


  onNoClick(): void {
    this.dialogRef.close();
  }



  centerDialog(): void {
    const dialogRefElement = this.dialogRef?.containerInstance?.hostElement;
    if (dialogRefElement) {
      const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      const dialogWidth = dialogRefElement.clientWidth;
      const dialogHeight = dialogRefElement.clientHeight;
      const top = Math.max(0, (windowHeight - dialogHeight) / 2);
      const left = Math.max(0, (windowWidth - dialogWidth) / 2);
      dialogRefElement.style.top = `${top}px`;
      dialogRefElement.style.left = `${left}px`;
    }
  }

  // "tableName": "dadosInterplantas",
  // "filterColumn": "dataPainel",
  // "referenceDate": "21/09/2023 00:00",
  // "numDays": 2,
  // "searchText": "All"
  async getItemsFromDynamoDB(): Promise<void> {
    this.referenceDate = this.convertTimestampToFormattedDate(Date.now());
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsVolumesAltos(this.query, this.urlConsultaCompactada, 'All', this.filterColumn, this.referenceDate, this.numDays)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });

      if (response.statusCode === 200) {
        try {
          // //console.log(response.body)
          const items = JSON.parse(response.body);
          // //console.log(items)
          if (Array.isArray(items)) {
            this.items = items
              // .filter(item => this.shouldIncludeItem(item))
              // .map(item => ({ ...item, checked: false }));
            this.cdr.detectChanges();
            // //console.log(items)
            this.isLoading = false;
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }


  shouldIncludeItem(item: any): boolean {
    const description = item.description ? item.description.toLowerCase() : '';
    if (this.milkRunSP && description.includes('prog')) {
      return true;
    }
    if (this.milkRunSul && (description.includes('sul') || description.includes('tcm'))) {
      return true;
    }
    return false;
  }

  async getVeiculosFromDynamoDB(): Promise<void> {
    try {
      const filtro = '';
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItems(this.query3, this.urlConsulta, filtro)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });

      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.veiculos = items.map(item => ({ ...item, checked: false }));
            this.cdr.detectChanges();
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }


  async getItemsFromArgentina(): Promise<void> {
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItems(this.query4, this.urlConsulta, '')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });

      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.argentina = items
              .filter(item => this.shouldIncludeArgentina(item))
              .map(item => ({ ...item, checked: false }));
            this.cdr.detectChanges();
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }


  shouldIncludeArgentina(item: any): boolean {
    const description = item.description ? item.description.toLowerCase() : '';
    if (this.milkRunArg && description.includes('arg')) {
      return true;
    }
    return false;
  }


  async getCarriersFromDynamoDB(): Promise<void> {
    const filtro = '';
    (await this.dynamodbService.getItems(this.query2, this.urlConsulta, filtro)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.carrier = items.map(item => ({ ...item, checked: false }));
              // Adiciona a chave 'checked' a cada item, com valor inicial como false
              // Forçar detecção de alterações após atualizar os dados
              this.cdr.detectChanges();
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }


  async deleteItem(Item: any, urlDeleta: string, query: string): Promise<void> {
    const confirmacao = window.confirm("Tem certeza que deseja confirmar a coleta neste ponto?");

    // Verifica se o usuário confirmou a ação
    if (confirmacao) {
      this.isLoading = true;
      const ID = Item.ID;
      await this.dynamodbService.deleteItem(ID, this.urlAtualiza, Item.tableName).subscribe(
        async response => {
          // setTimeout(() => {
          await this.ngOnInit();
          // }, 1200); // Ajuste o tempo de atraso conforme necessário
        },
        error => {
          // Lógica para lidar com erros durante a deleção do item
        }
      );
    }

  }

  async milkRunSPFilter() {
    //console.log("clicou")
    this.isLoading = true;
    if (this.milkRunSP === true) {
      this.milkRunSP = false;
    } else {
      this.milkRunSP = true;
    }

    // setTimeout(() => {
    await this.ngOnInit();
    // }, 200);

  }

  async milkRunSulFilter() {
    this.isLoading = true;
    if (this.milkRunSul === true) {
      this.milkRunSul = false;

    } else {
      this.milkRunSul = true;

    }
    // setTimeout(() => {
    await this.ngOnInit();
    // }, 200);

  }

  async milkRunArgFilter() {
    this.isLoading = true;
    if (this.milkRunArg === true) {
      this.milkRunArg = false;
    } else {
      this.milkRunArg = true;
    }
    // setTimeout(() => {
    await this.ngOnInit();
    // }, 200);
  }

  async getUserLogado() {
    // //console.log("logado")
    // //console.log(this.autenticacaoService?.obterUsuarioLogado())
    this.usuarioLogado = await this.servicoAutenticacao.obterUsuarioLogado()
    await this.enableFields();
    await this.enableFieldsTCM();
    await this.enableFieldsLOTS();
    await this.enableFieldsJSL();
    await this.enableFieldsJSLARG();
    await this.enableFieldsJSLVW();
    // //console.log(this.usuarioLogado)
    // //console.log(this.isCarrierEnabled)
    // //console.log(this.isCarrierTCMEnabled)
    // //console.log(this.isCarrierJSLARGEnabled)
    // //console.log(this.isCarrierLOTSEnabled)
    // //console.log(this.isCarrierJSLVWEnabled)
  }

  navigateTo(route: string): void {
    this.router.navigateByUrl(route);
  }

  enableFields() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "TCM")) {
      this.isCarrierEnabled = false;
    }
  }

  enableFieldsTCM() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "TCM")) {
      this.isCarrierTCMEnabled = false;
    }
  }

  enableFieldsJSL() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "JSL")) {
      this.isCarrierJSLEnabled = false;
    }
  }

  enableFieldsJSLARG() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "JSL-ARG")) {
      this.isCarrierJSLARGEnabled = false;
    }
  }

  enableFieldsLOTS() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "LOTS")) {
      this.isCarrierLOTSEnabled = false;
    }
  }

  enableFieldsJSLVW() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "JSL-VW")) {
      this.isCarrierJSLVWEnabled = false;
    }
  }

  // Função para ajustar os valores numéricos em um objeto
  adjustNumericValues(obj: any) {
    const adjustedObj = {} as Record<string, any>;
    for (const prop in obj) {
      if (typeof obj[prop] === 'number') {
        adjustedObj[prop] = obj[prop].toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 });
      } else if (typeof obj[prop] === 'object') {
        adjustedObj[prop] = this.adjustNumericValues(obj[prop]);
      } else {
        adjustedObj[prop] = obj[prop];
      }
    }
    return adjustedObj;
  }

  //EXPORTAR EXCEL
  exportExcel() {
    const confirmacao = window.confirm("Todas as informações devem estar preenchidas. Campos em vermelho impedem a exportação do arquivo!");

    // Verifica se o usuário confirmou a ação
    if (confirmacao) {
      this.isLoading = true;
      try {
        // Criar um novo array com valores numéricos ajustados
        const newArrayWithAdjustedValues = this.filteredItems.map(item => this.adjustNumericValues(item));
        this.itemToExport = newArrayWithAdjustedValues;
        this.itemToExport.forEach((item, index) => this.dataMilissegundos[index] = parseInt((item.date.replace(/[.,]/g, '')).toString().slice(0, -2)))
        // //console.log(this.dataMilissegundos)

        // Filtrar e selecionar apenas os itens que você deseja exportar
        this.itemToExport = this.itemToExport.map((item, index) => ({
          // Data: typeof item.date == 'string' ? this.formatStringDate(item.date) : this.formatMillisecondsToDate(this.dataMilissegundos[index]),
          Data: this.addTimeStringToDate(item),
          Vehicle_configuration: item["Transport Type"],
          License_Plate: item.Plate,
          Ponto_Coleta1: item["Fornecedor 1"],
          Ponto_Coleta2: item["Fornecedor 2"],
          Ponto_Coleta3: item["Fornecedor 3"],
          Ponto_Coleta4: item["Fornecedor 4"],
          Ponto_Entrega1: item["Destino 1"],
          Ponto_Entrega2: item["Destino 2"],
          Ponto_Entrega3: item["Destino 3"],
          Ponto_Entrega4: item["Destino 4"],
          Qtde_Itens: parseFloat(item.Volumes.replace(/\./g, "").replace(",", ".")),
          Cubagem_m3: parseFloat(item.Cubage.replace(/\./g, "").replace(",", ".")),
          Peso_Total_Kg: parseFloat(item["Weight Loaded"].replace(/\./g, "").replace(",", ".")),
          // Distancia: parseFloat(item["Total Distance"]),
          Distancia: parseFloat(item["Total Distance"].replace(/\./g, "").replace(",", ".")),
          Custo_Viagem: parseFloat(item["Total Cost"].replace(/\./g, "").replace(",", "."))
        }));
        //console.log(this.filteredItems)
        const fileName = 'Relatório E-Transport'; // Nome do arquivo Excel
        this.exportSubsetToExcel(this.itemToExport, fileName);
      }
      catch (error) {
        this.isLoading = false;
        window.confirm("ERRO!!! Verifique o preenchimento dos campos!");
        console.error('Error parsing JSON:', error);
      }
    }
    this.isLoading = false;
  }

  addTimeStringToDate(item: any): string {
    var newDate;
    if (item.date.includes("T")) {
      newDate = this.formatStringDate(item.date)
    } else {
      var data = parseInt((item.date.replace(/[.,]/g, '')).toString().slice(0, -2))
      newDate = this.formatMillisecondsToDate(data)
    }

    return newDate;
  }

  // Função para exportar um subconjunto específico do objeto para um arquivo Excel
  exportSubsetToExcel(subsetData: any[], fileName: string) {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(subsetData);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, fileName + '.xlsx');
  }

  formatMillisecondsToDate(milliseconds: number) {
    //console.log(milliseconds)
    const date = new Date(milliseconds);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
  }

  formatStringDate(inputDate: string) {
    const date = new Date(inputDate);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
  }

}
